import { createContext, useContext, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const OnboardingContext = createContext(undefined);

export function OnboardingProvider({ children }) {
  const location = useLocation();
  const { user } = useAuth();
  const [step1Data, setStep1Data] = useState(null);

  const queryEmail = new URLSearchParams(location.search).get("email") || "";
  const stateEmail = location.state?.email || "";
  const userEmail = user?.data?.email || "";

  const email = useMemo(() => {
    return (stateEmail || queryEmail || userEmail).trim().toLowerCase();
  }, [queryEmail, stateEmail, userEmail]);

  const value = useMemo(
    () => ({
      step1Data,
      setStep1Data,
      email,
    }),
    [step1Data, email],
  );

  return (
    <OnboardingContext.Provider value={value}>
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboarding() {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error("useOnboarding must be used within OnboardingProvider");
  }
  return context;
}
